export default __webpack_public_path__ + "static/media/building.dbb64392.svg";